import { Image, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { FetchFileFromS3 } from "Utility/Helpers/Storage";

function UploadProfilePic({
  S3Key,
  src = null,
  className,
  imagePreviewStyle,
  width = 184,
  height = 184,
  ...rest
}) {
  const [imageURL, setImageURL] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (S3Key) {
        await fetchURL(S3Key);
      }
    })();
  }, [S3Key]);

  const fetchURL = async (key) => {
    setIsLoading(true);
    try {
      const url = await FetchFileFromS3(key);
      if (url) {
        setImageURL(url);
      } else {
        setImageURL(null); // Handle undefined url
      }
    } catch (error) {
      console.error("Failed to fetch image from S3:", error);
      setImageURL(null); // Optional: Display a placeholder or error image
    } finally {
      setIsLoading(false);
    }
  };

  const getImagePath = () => (src ? src : imageURL ? imageURL : undefined);

  return (
    <div
      className={`flex items-center justify-center aspect-square`}
      style={{ width, height }}
    >
      {isLoading ? (
        <Skeleton.Image
          active
          shape="circle"
          className="w-full h-full rounded-full object-cover aspect-square"
          style={{ width, height }}
        />
      ) : (
        <Image
          {...rest}
          preview={false}
          src={getImagePath()}
          className={`object-cover aspect-square w-full h-full rounded-full ${imagePreviewStyle} ${className}`}
          style={{ width, height }}
        />
      )}
    </div>
  );
}

export default UploadProfilePic;
